export default "__VITE_ASSET__C4h1QcJn__"